/**
 * The iOS app's native swipe-back gesture (EP-122), switched from the web.
 *
 * `mobile/ios/App/App/ViewController.swift` registers a `swipeBack` message
 * handler that sets `allowsBackForwardNavigationGestures`. Builds from before
 * 2026-09-29 have no handler, so nothing here can switch the gesture there and
 * `canControlNativeSwipeBack()` is false; callers leave the native gesture
 * alone in that case.
 */
interface SwipeBackHandler {
  postMessage: (enabled: boolean) => void
}

function swipeBackHandler(): SwipeBackHandler | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as unknown as { webkit?: { messageHandlers?: { swipeBack?: SwipeBackHandler } } }).webkit
    ?.messageHandlers?.swipeBack
}

export function canControlNativeSwipeBack(): boolean {
  return swipeBackHandler() !== undefined
}

export function setNativeSwipeBack(enabled: boolean): void {
  swipeBackHandler()?.postMessage(enabled)
}
